/*
 * @Descripttion:
 * @version:
 * @@Company: HDWB
 * @Author: cwl
 * @Date: 2022-04-11 13:43:44
 * @LastEditors: cwl
 * @LastEditTime: 2022-07-28 15:32:13
 */
import axios from 'axios'
import errorCode from './errorCode'
import {Local, goSso} from './utils'
import { Notification, Message } from 'element-ui'
import store from '../store/store'
// let baseUrl_mock = 'https://easy-mock.com'
// let baseUrl = ''

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
    timeout: 10000
})

// request拦截器
service.interceptors.request.use(
    config => {
    // 是否需要设置 token
        const isToken = (config.headers || {}).isToken === false
        if (store.state.token && !isToken) {
            // if (Local.get('token') && !isToken) {
            config.headers['Authorization'] = 'Bearer ' + store.state.token // 让每个请求携带自定义token 请根据实际情况自行修改
            if (config.hasNoBear) {
                config.headers['Authorization'] = store.state.token // 让每个请求携带自定义token 请根据实际
              }
        }
        return config
    },
    error => {
        console.log(error)
        Promise.reject(error)
    }
)

// 响应拦截器
service.interceptors.response.use(
    res => {
    // 未设置状态码则默认成功状态
        const code = res.data.code || res.data.status || 200
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode['default']
        if (code === 401 || code === 405) {
            console.log(res.config.url.includes('logout'))
            if (res.config.url.includes('logout')) return
            Local.remove('token')
            Message({
                message: '登录状态已过期,请重新登陆',
                type: 'error'
            })
            setTimeout(() => {
                store.commit('SET_TOKEN', '')
                const returnUrl = window.location.origin
                goSso(returnUrl, store.state.ssoLoginJumpUrl)
            }, 2000)
            // MessageBox.confirm('登录状态已过期，您可以继续留在该页面，或者重新登录', '系统提示', {
            //   confirmButtonText: '重新登录',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // }).then(() => {})
        } else if (code === 500) {
            Message({
                message: msg,
                type: 'error'
            })
            return Promise.reject(new Error(msg))
        } else if (code !== 200 && code !== 1) {
            Notification.error({
                title: msg
            })
            return Promise.reject('error')
        } else {
            return res.data
        }
    },
    error => {
        console.log('err' + error)
        let { message } = error
        if (message == 'Network Error') {
            message = '后端接口连接异常'
        } else if (message.includes('timeout')) {
            message = '网络开小差了，请稍后'
        } else if (message.includes('Request failed with status code')) {
            message = '系统接口' + message.substr(message.length - 3) + '异常'
        }
        Message({
            message: message,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service



// WEBPACK FOOTER //
// ./src/lib/request.js